import { Fragment } from "react";
import classnames from "classnames";
import Proptypes from "prop-types";
import { AccordionBody, AccordionItem, UncontrolledAccordion, AccordionHeader, Accordion } from "reactstrap";

const Accordions = (props) => {
    const { className = "", items, controlled = false, state = null, toggle = () => {} } = props;

    const CustomAccordion = controlled ? Accordion : UncontrolledAccordion;

    const accordionProps = controlled ? {
        open: state,
        toggle
    } : {
        defaultOpen: items.map((item) => item.id)
    };
    return (
        <CustomAccordion
            {...accordionProps}
            className={classnames("accordion-margin", className)}>
            {items.map((item) => !item.omit && (
                <Fragment key={item.id}>
                    <AccordionHeader targetId={item.id}>{item.title}</AccordionHeader>
                    <AccordionItem>
                        <AccordionBody accordionId={item.id}>{item.content}</AccordionBody>
                    </AccordionItem>
                </Fragment>
            ))}
        </CustomAccordion>
    );
};

export default Accordions;

Accordions.prototypes = {
    className : Proptypes.string,
    items     : Proptypes.arrayOf(Proptypes.object).isRequired,
    controlled: Proptypes.bool,
    state     : Proptypes.string,
    toggle    : Proptypes.func

};
